/**
 * PickupSystem — Magnet behavior for XP gems and items
 *
 * When pickups are within the player's pickup radius,
 * they accelerate toward the player for that satisfying
 * "magnet" feel (like Vampire Survivors).
 */

export class PickupSystem {
  update(dt, entities, engine) {
    const player = entities.queryTag('player')[0];
    if (!player) return;

    const playerPos = entities.getComponent(player, 'position');
    const pickups = entities.queryTag('pickup');

    for (const pickupId of pickups) {
      if (!entities.isAlive(pickupId)) continue;
      const pPos = entities.getComponent(pickupId, 'position');

      const dx = playerPos.x - pPos.x;
      const dy = playerPos.y - pPos.y;
      const dist = Math.sqrt(dx * dx + dy * dy) || 1;

      // Within magnet range — accelerate toward player
      if (dist < engine.playerStats.pickupRadius * 2.5) {
        const speed = 300 + (1 - dist / (engine.playerStats.pickupRadius * 2.5)) * 500;
        pPos.x += (dx / dist) * speed * dt;
        pPos.y += (dy / dist) * speed * dt;
      }
    }
  }
}
